import { render } from "./chooseDifficulty.vue?vue&type=template&id=e8cb4a44"
import script from "./chooseDifficulty.vue?vue&type=script&lang=js"
export * from "./chooseDifficulty.vue?vue&type=script&lang=js"
script.render = render

export default script